module.exports = __webpack_public_path__ + "img/1561570476.0035ccb7.jpg";